export default __webpack_public_path__ + "static/media/newcas.8a82ce7a.png";